// extracted by mini-css-extract-plugin
module.exports = {"backTopBtn":"backTop-module--backTopBtn--_BB56","fadeIn":"backTop-module--fadeIn--23lBZ","arrowIcon":"backTop-module--arrowIcon--1Mae5"};